module.exports = __webpack_public_path__ + "static/media/egg_bg_kuang.0c2e61cd.png";